import { Box, Typography } from '@mui/material'
import type { ProcurementFilters } from '../ProcurementPage'

interface Props {
  filters: ProcurementFilters
}

export default function ProcurementPayDataListView({ filters }: Props) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="h6" fontWeight={700}>
        Pay Data
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This tab will host the Procurement Pay Data toolbar and list mapped from
        {' '}
        <strong>form_frmProcurementMainSubFormPayData.txt</strong>
        {' '}
        and
        {' '}
        <strong>form_frmProcurementQryPayData.txt</strong>
        , including New / Delete / Edit / Send DNTT / XNTT / Add Invoice / Copy / Change Bank / VAT actions.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Current header filters: startDate={filters.startDate}, endDate={filters.endDate}, isForcedClose=
        {filters.isForcedClose}
        .
      </Typography>
    </Box>
  )
}

